"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactCollapsible = _interopRequireDefault(require("react-collapsible"));
var _classnames = _interopRequireDefault(require("classnames"));
var _constants = require("../../constants");
var Original = function Original(_ref) {
  var heading = _ref.heading,
    children = _ref.children,
    noPadding = _ref.noPadding,
    on = _ref.on,
    toggle = _ref.toggle,
    noBorder = _ref.noBorder,
    lgHeader = _ref.lgHeader,
    flip = _ref.flip,
    className = _ref.className,
    inlineHeader = _ref.inlineHeader,
    inlineChevron = _ref.inlineChevron,
    hideChevron = _ref.hideChevron;
  return /*#__PURE__*/_react["default"].createElement(_reactCollapsible["default"], {
    className: (0, _classnames["default"])('d8-c-collapse-original', hideChevron && 'hide-chevron', noPadding && 'no-padding', noBorder && 'no-border', lgHeader && 'large-header', flip && 'flip-chevron', className, inlineHeader && 'inline-header', inlineChevron && 'inline-chevron'),
    openedClassName: (0, _classnames["default"])('d8-c-collapse-original', hideChevron && 'hide-chevron', noPadding && 'no-padding', noBorder && 'no-border', lgHeader && 'large-header', flip && 'flip-chevron', className, inlineHeader && 'inline-header', inlineChevron && 'inline-chevron'),
    trigger: heading,
    triggerTagName: "header",
    easing: _constants.EASING.BOUNCE(),
    transitionTime: 200,
    open: on,
    handleTriggerClick: toggle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-collapse--content"
  }, children));
};
Original.propTypes = {
  heading: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,
  noPadding: _propTypes["default"].bool,
  noBorder: _propTypes["default"].bool,
  lgHeader: _propTypes["default"].bool,
  flip: _propTypes["default"].bool,
  on: _propTypes["default"].bool,
  inlineHeader: _propTypes["default"].bool,
  toggle: _propTypes["default"].func,
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].func]).isRequired,
  className: _propTypes["default"].string,
  inlineChevron: _propTypes["default"].bool,
  hideChevron: _propTypes["default"].bool
};
var _default = exports["default"] = Original;